export const Features = (props) => {
  return (
    <div id='features' className='text-center'>
      <div className='container'>
        <div className='col-md-10 col-md-offset-1 section-title'>
          <h2 style={{marginTop:"100px"}}>TECHNOLOGIES</h2>
          <p>Net Wave provide solutions and services across a wide-ranging technology. Our international network of accredited engineers empowers us to support the leading-edge technologies.</p>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className='col-sm-4' style={{height:"350px",paddingTop:"10px"}}>
                  {' '}
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : 'Loading...'}
        </div>
      </div>
    </div>
  )
}
